import Contact from "~/components/header/contacts/item"
import type { Contact as ContactProps } from "~/components/header/types"

export interface Props {
    contacts: ContactProps[]
}

export default function Contacts({ contacts }: Props) {
    if (!contacts?.length) return null

    return (
        <div className='space-y-4 mb-4 lg:space-y-0 lg:mb-0 lg:flex lg:items-center lg:justify-center lg:gap-5'>
            {contacts.map((c, i) => <Contact key={c.url ?? i} {...c} />)}
        </div>
    )
}
